import styled from 'styled-components';

export const Container = styled.button(({ theme }) => ({
  cursor: 'pointer',
  marginLeft: '10rem',
  padding: '0rem',
  border: 'none',
  backgroundColor: 'transparent',

  svg: {
    stroke: theme.defaultTheme.primaryColor,
  },

  '&[disabled]': {
    opacity: 0.6,
    cursor: 'not-allowed',

    svg: {
      stroke: theme.defaultTheme.disabledColor,
    },
  },
}));
